import script from "./radio.vue?vue&type=script&setup=true&lang=js"
export * from "./radio.vue?vue&type=script&setup=true&lang=js"

import "./radio.vue?vue&type=style&index=0&id=44cb6072&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44cb6072"]])

export default __exports__